import { render, staticRenderFns } from "./UnitContingentForm.vue?vue&type=template&id=56c642b2&scoped=true&"
import script from "./UnitContingentForm.vue?vue&type=script&lang=js&"
export * from "./UnitContingentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c642b2",
  null
  
)

export default component.exports